export const environment = {
    apiKey : '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',
    assistantsBaseAPIUrl : 'https://api.openai.com/v1/assistants',
    threadsBaseAPIUrl : 'https://api.openai.com/v1/threads',
    assistantId : 'asst_3eTPsd2iqwy5XqJJrsrSJiVJ'
};
